import { modifier } from 'ember-modifier';

interface LoaderEllipsisSignature {
  Element: HTMLElement;
  Args: {
    Positional: [];
  };
}

export default modifier<LoaderEllipsisSignature>(
  function loaderEllipsis(element /*, positional, named*/) {
    let count = 0;
    element.textContent = '.';
    const interval = setInterval(() => {
      count = (count + 1) % 3;
      element.textContent = '.'.repeat(count + 1);
    }, 300);

    return () => clearInterval(interval);
  },
);
